// retorna o preço completo de um produto
const fullPrice = (item) => {
  let result = item.originalPrice;

  if (item.complements && item.complements.length) {
    item.complements.forEach((comp) => {
      result += comp.price * comp.quantity;
    });
  }

  return result;
};

// retorna o preço total de um produto
const totalPrice = (item) => fullPrice(item) * item.quantity;

export { fullPrice, totalPrice };
